import React, {useEffect} from 'react';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './RestaurantImage.module.scss';

interface RestaurantImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const tuningOffset = 500;

const RestaurantImage = ({className, ...props}: RestaurantImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.restaurant.isOpen) {
      setTimeout(animations.restaurant.hide, animationDuration - tuningOffset);
    }
  }, [animations.restaurant.isOpen]);

  return animations.restaurant.isOpen && (
    <img src={animations.restaurant.image} alt="restaurant" className={classNames(styles.image, className)} {...props} />
  );
};

export default RestaurantImage;